var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.8325 22.2227H61.5825V44.4047H64.8325V22.2227Z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2629 22.2227H39.0129V44.4047H42.2629V22.2227Z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1595 100.956H28.6853L39.2632 37.9307H64.5832L75.1595 100.956ZM32.5268 97.7063H71.3196L61.8329 41.1807H42.0127L32.5268 97.7063Z",
    fill: "#1C1C1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3828 21.831L25.6896 19.0571L51.9219 3.04358L78.1527 19.0571L76.4594 21.831L51.9219 6.85177L27.3828 21.831Z",
    fill: "#1C1C1C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3828 40.7778L25.6896 38.0031L51.9219 21.9895L78.1527 38.0031L76.4594 40.7778L51.9219 25.7977L27.3828 40.7778Z",
    fill: "#1C1C1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7341 63.2977H37.0159V66.5477H67.7341V63.2977Z",
    fill: "#1C1C1C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3172 26.3315H77.0672V22.3478H23.8127V26.3315H20.5627V19.0978H80.3172V26.3315Z",
    fill: "#1C1C1C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3172 44.9092H77.0672V40.9255H23.8127V44.9092H20.5627V37.6755H80.3172V44.9092Z",
    fill: "#1C1C1C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5755 97.7063H0V100.956H23.5755V97.7063Z",
    fill: "#1C1C1C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M104 97.7063H80.4261V100.956H104V97.7063Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTower);
export default __webpack_public_path__ + "static/media/tower.0635e6abc0e24a2319adb5699c6caac6.svg";
export { ForwardRef as ReactComponent };